<template>
  <validation-provider v-slot="{ errors }" mode="eager" :name="tag.description">
    <v-textarea
      :id="`form-text-area-${tag.name}`"
      v-model="formData"
      :label="tag.description"
      outlined
      dense
      :error-messages="errors"
      :readonly="readonly"
      no-resize
      counter="1000"
      maxlength="1000"
      rows="6"
    />
  </validation-provider>
</template>

<script>
import { computed } from "vue";

export default {
  props: {
    value: {
      type: String,
      default: ""
    },
    tag: {
      type: Object,
      required: true
    },
    readonly: {
      type: Boolean,
      default: false
    }
  },

  setup(props, { emit }) {
    const formData = computed({
      get: () => props.value,
      set: val => emit("input", val)
    });

    return {
      formData
    };
  }
};
</script>
